@if (isLoading()) {
    <div
        class="wk-app-loader__container"
        [class.wk-app-loader__container--button]="size() === AppLoaderSize.Button"
        [class.wk-app-loader__container--small]="size() === AppLoaderSize.Small"
        [class.wk-app-loader__container--large]="size() === AppLoaderSize.Large"
        [class.wk-app-loader__container--overlay]="isOverlay()"
        [class.wk-app-loader__container--inline]="!isOverlay()"
        [class.wk-app-loader__container__position--left]="position() === AppLoaderPosition.Left"
    >
        <icon-pds3
            class="wk-app-loader__icon"
            [class.wk-app-loader__icon--white]="size() === AppLoaderSize.Button"
            [class.wk-app-loader__icon--small]="size() === AppLoaderSize.Small"
            [class.wk-app-loader__icon--large]="size() === AppLoaderSize.Large"
            name="wk-icon-spinner"
            [isSpin]="true"
        />
        @if (text()) {
            <div class="wk-app-loader__container-title">{{ text() | wkTranslate }}</div>
        }
    </div>
}
